import React, { Component } from 'react';
import Outbox from './Outbox.js';

export default class OutboxNotaDinas extends Component {
  render() {
    return (
      <Outbox type='TNDE_NOTA_DINAS'/>
    );
  }
}
